/**
 * BlackFridayProvider - Thin provider for Black Friday page
 *
 * Delegates all logic to useBlackFridayState composition hook.
 * Uses React 19 context syntax (<Context value={}> without .Provider).
 */

import { createContext, useContext } from 'react'

import { useBlackFridayState } from '../../hooks/blackFriday/useBlackFridayState'

import type { BlackFridayContextValue } from '../../types/domain'
import type { ReactNode } from 'react'

const BlackFridayContext = createContext<BlackFridayContextValue | null>(null)

interface BlackFridayProviderProps {
  children: ReactNode
}

export function BlackFridayProvider({ children }: BlackFridayProviderProps) {
  const state = useBlackFridayState()

  return (
    <BlackFridayContext value={state}>
      {children}
    </BlackFridayContext>
  )
}

export function useBlackFriday(): BlackFridayContextValue {
  const context = useContext(BlackFridayContext)
  if (!context) {
    throw new Error('useBlackFriday must be used within BlackFridayProvider')
  }
  return context
}
